<template>
  <div>
    <b-table
      hover
      :items="items"
    >
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-1" variant="secondary"></b-spinner>
          <strong class="text-secondary">Loading...</strong>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { BSpinner, BTable } from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
    BCardCode,
    BTable,
  },
  data() {
    return {
      items: [],
    }
  },
  props: {
    topDivision: {
      type: Object,
      default: () => ({}),
    }
  },
  watch: {
    topDivision: {
      handler(newVal) {
        let items = []
        // for(const i of newVal){
        //   items.push({
        //     top_5_favorite: i.name,
        //     total: i.total,
        //   })
        // }
        for (let index = 0; index < 5; index++) {
          items.push({
            top_5_division: newVal[index] ? newVal[index].name : '-',
            total: newVal[index] ? newVal[index].total : '-',
          })
        }
        this.items = items
      },
      immediate: true, // agar langsung dijalankan saat komponen dimount
      deep: true, // jika kamu ingin mengamati perubahan dalam objek
    }
  }
}
</script>